module.exports = __webpack_public_path__ + "static/media/search-icon.5d23464c.gif";